import React, { useState } from "react";
import Question from "../../components/Question";
import Answer from "../../components/Answer";
import questions from "./questionSet.js";
import MobileText from "../../components/MobileText/index.jsx";
import { withOrientationChange } from "react-device-detect";

const RouterScreen = (props) => {
  const { isPortrait } = props;

  const [currentScreen, setCurrentScreen] = useState("Question");
  const [answers, setAnswers] = useState({})
  const [questionIndex, setQuestionIndex] = useState(0)

  return (
    <>
      {currentScreen === "Question" && !isPortrait && (
        <Question setCurrentScreen={setCurrentScreen} setAnswers={setAnswers} question={questions[questionIndex]} />
      )}
      {currentScreen === "Answer" && !isPortrait && (
        <Answer setCurrentScreen={setCurrentScreen} question={questions[questionIndex]} answers={answers} />
      )}
      {isPortrait && <MobileText isOpen={isPortrait} />}
    </>
  );
};

export default withOrientationChange(RouterScreen);
